import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import UserPermissionsReducer from '../reducers/userPermissionsReducer';
import ProfilePermissionsReducer from '../reducers/profilePermissionsReducer';
import { getAccessTokenOrCookie } from '../../common/atoms/Login/login.util';

// move this to a util file
const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_API_BASEURL}/users`,
  prepareHeaders: (headers) => {
    const accessToken = getAccessTokenOrCookie();
    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`);
    }
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
    return headers;
  },
});

export const permissionsApi = createApi({
  reducerPath: 'permissionsApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Permissions'],
  endpoints: (builder) => ({
    profilePermissions: builder.query({
      queryFn: async ({ userId, targetProfile }, api, extraOptions, baseQuery) => {
        if (userId && targetProfile) {
          const resp = await baseQuery({
            url: `/profile/permissions/${userId}`,
            method: 'GET',
          });
          const permissions = ProfilePermissionsReducer({ remotePermissions: resp.data });
          return { data: permissions };
        }
        return { data: null };
      },
      providesTags: (result) => (result ? [{ type: 'Permissions', id: 'profileTarget' }] : []),
    }),
    userPermissions: builder.query({
      queryFn: async ({ user }, api, extraOptions, baseQuery) => {
        if (user) {
          const { data: { permissions } } = await baseQuery({ url: '/current-user/permissions', method: 'GET' });
          return { data: UserPermissionsReducer(user, permissions) };
        }
        return { data: null };
      },
      providesTags: (result) => (result ? [{ type: 'Permissions', id: 'user' }] : []),
    }),
  }),
});

export const { useProfilePermissionsQuery, useUserPermissionsQuery } = permissionsApi;
